import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const DoorLiteFrame = ({ value, onChange, isVisible, label = 'Lite Frame' }) => { 
    const [selectedDoorLiteFrame, setSelectedDoorLiteFrame] = useState(value || "StainablePVC");

    const handleDoorLiteFrameChange = (e) => {
        const newValue = e.target.value;
        setSelectedDoorLiteFrame(newValue);
        onChange(newValue);
    };

    useEffect(() => {
        console.log("Frame isVisible===>", isVisible);
        if (isVisible && isVisible === 1) {
            // Make it visible and set the default value to "Center"
            setSelectedDoorLiteFrame("StainablePVC");
            onChange("StainablePVC");
        }
    }, [isVisible, onChange]);
    
    return (
        <div className="a-container" >
            <label  style={{ display: isVisible === "1" ? 'block' : 'none' }} htmlFor="DoorLiteFrame">{label}</label>
            <select style={{ display: isVisible === "1" ? 'block' : 'none' }}
                id="DoorLiteFrame"
                value={selectedDoorLiteFrame}
                onChange={handleDoorLiteFrameChange}
            >
              <option value="" disabled hidden>Select Collection</option>  
              <option value='StainablePVC'>{selectedDoorLiteFrame === 'StainablePVC' ? 'Stainable PVC ✔' : 'Stainable PVC'}</option>
              <option value='RegaleadClay'>{selectedDoorLiteFrame === 'RegaleadClay' ? 'Regalead Clay ✔' : 'Regalead Clay'}</option>
            </select>
        </div>
    );
};

export default DoorLiteFrame;
